import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { canAccessPath } from '@/lib/permissions';

/**
 * The nightly number check (api services/numberCheck) found a gap on the
 * latest day it checked: an order the store has and we do not, daily numbers
 * a rebuild did not clear, an order with no outcome at Meta, spend that
 * differs from Meta's. One row in the Alerts bell until the next check comes
 * back clean; the page names every order and account.
 */
const fmtDay = (d) => (d ? new Date(`${d}T00:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' }) : '');

/** Pure: the alert row for GET /api/number-check?days=1, or null. */
export function numberCheckAlertOf(data) {
  const latest = data && data.latest;
  if (!latest || !latest.summary || !latest.summary.gap) return null;
  const day = (data.days || []).find((d) => d.day === latest.day);
  const labels = day ? day.checks.filter((c) => c.status === 'gap').map((c) => c.label) : [];
  const n = latest.summary.gap;
  const named = labels.length > 3 ? `${labels.slice(0, 3).join(', ')} and ${labels.length - 3} more` : labels.join(', ');
  return {
    id: 'number-check-gap',
    tone: 'warn',
    text: `Number check found ${n === 1 ? 'a gap' : `${n} gaps`} on ${fmtDay(latest.day)}${named ? `: ${named}` : ''}`,
    to: '/number-check',
    linkLabel: 'See what differs',
  };
}

export function useNumberCheckAlerts() {
  const allowed = canAccessPath('/number-check');
  const { data } = useQuery({
    queryKey: ['number-check', 'bell'],
    queryFn: async () => (await api.get('/api/number-check', { params: { days: 1 } })).data,
    enabled: allowed,
    staleTime: 10 * 60_000,
    refetchInterval: 30 * 60_000,
    retry: false,
  });
  const row = allowed ? numberCheckAlertOf(data) : null;
  return row ? [row] : [];
}
